module.exports = __webpack_public_path__ + "img/ch19.7e52db4f.jpg";